import { apiClient } from '@/lib/api-client';
import { SinaremReportsApiDatasource } from '../data/datasources/sinarem-reports-api.datasource';
import { SinaremReportsRepositoryImpl } from '../data/repositories/sinarem-reports.repository.impl';

const apiDatasource = new SinaremReportsApiDatasource(apiClient);
const repository = new SinaremReportsRepositoryImpl(apiDatasource);

export const sinaremReportsContainer = { repository };
